<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="frontmatter">
<p class="epig1"><span class="right_1" epub:type="pagebreak" id="page_ii" title="ii">COUNTERPOINTS: MUSIC AND EDUCATION</span></p>
<p class="epig">Estelle R. Jorgensen, <i>editor</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 00a_Yob_and_Jorgensen_fm_prod0a.vue?fc02eb64